'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const EmptyStateTitle = renderWithRef('EmptyStateTitle', null, (r, o)=>jsx(RenderComp, {
        root: "p",
        forwardedRef: o,
        classNames: [
            'swan-empty-state-title'
        ],
        props: r,
        children: r.children
    }));

export { EmptyStateTitle };
